import React, { useState } from "react";
import type { State, County } from "../../../shared/types/models/location";
import { useUserContext } from "../config/UserContext";
import PropertyIndexSearch from "./PropertyIndexSearch";

interface SearchCardProps {
  onSearch: (payload: { mode: 'property' | 'deed'; reference: string; reference2To?: string; frozenDeedLookup?: string }) => void;
  state: State | null;
  county: County | null;
}

const SearchCard: React.FC<SearchCardProps> = ({ onSearch, state, county }) => {
  const { apiBaseUrlLoading, apiBaseUrlError } = useUserContext();
  const [searchMode, setSearchMode] = useState<'property' | 'deed'>('property');
  const [deedLookup, setDeedLookup] = useState('');

  if (apiBaseUrlLoading) {
    return <div>Loading configuration...</div>;
  }
  if (apiBaseUrlError) {
    return <div>Error loading configuration: {apiBaseUrlError}</div>;
  }

  return (
    <div className="bg-white rounded-2xl px-8 py-6 flex flex-col items-center max-w-md w-full shadow-sm border border-gray-100">
      <h2 className="text-[24px] font-bold text-[#141435] mb-2 text-center font-plus-jakarta">
        Search / Lookup
      </h2>
      <p className="text-[#485D7D] text-[14px] text-center mb-6 font-plus-jakarta">
        Find an existing Frozen Deed or lookup a Property Record
      </p>

      {/* Tabs */}
      <div className="flex w-full mb-6 bg-gray-100 rounded-lg p-1">
        <button
          className={`flex-1 py-2 text-sm font-semibold rounded-md transition-colors ${searchMode === 'property' ? 'bg-white shadow text-[#0B4BB6]' : 'text-gray-500 hover:text-gray-700'}`}
          onClick={() => setSearchMode('property')}
        >
          Property Info
        </button>
        <button
          className={`flex-1 py-2 text-sm font-semibold rounded-md transition-colors ${searchMode === 'deed' ? 'bg-white shadow text-[#0B4BB6]' : 'text-gray-500 hover:text-gray-700'}`}
          onClick={() => setSearchMode('deed')}
        >
          Frozen Deed #
        </button>
      </div>

      {searchMode === 'property' ? (
        <PropertyIndexSearch
          state={state}
          county={county}
          onSearch={(vals) => onSearch({ mode: 'property', ...vals })}
        />
      ) : (
        <form className="w-full flex flex-col gap-4" autoComplete="off" onSubmit={(e) => {
          e.preventDefault();
          if (deedLookup.trim()) {
            onSearch({ mode: 'deed', reference: '', frozenDeedLookup: deedLookup.trim() });
          }
        }}>
          <div className="flex flex-col gap-1 w-full">
            <label className="text-[#485D7D] text-[13px] font-medium font-plus-jakarta">
              Frozen Deed Number
            </label>
            <input
              name="fzd_deed_lookup"
              type="text"
              autoComplete="new-password"
              value={deedLookup}
              onChange={e => setDeedLookup(e.target.value)}
              className="w-full px-3 py-2 rounded border border-[#D7DFEC] bg-white text-[#141435] text-[15px] font-semibold font-plus-jakarta focus:outline-none focus:ring-1 focus:ring-[#0B4BB6]"
              placeholder="e.g. fd-1234..."
              required
            />
          </div>
          <button
            type="submit"
            className="w-full bg-[#0B4BB6] text-white font-bold text-[15px] font-plus-jakarta py-2 rounded-full mt-2 hover:bg-[#23235a] transition-colors border-2 border-[#0B4BB6] disabled:opacity-50"
            disabled={!deedLookup.trim()}
          >
            Search
          </button>
        </form>
      )}
    </div>
  );
};

export default SearchCard; 